// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__pUekK","wrap__shortView":"styles_wrap__shortView__NAQxp"};